<div class="row">
  <div class="col-6">
    <h3 class="enif-title float-center">Selecione o combustível desejado e atualize o <strong
      class="enif-uppercase">Preço.</strong>
    </h3>
  </div>

  <div class="col-4" *ngIf="postotemPermissaoUplodCsv">
    <button 
    class="btn btn-terceary float-end" 
    routerLink="/upload-csv">Atualizar preços com CSV
  </button>
  <!-- <button 
  class="btn btn-terceary float-end" 
  routerLink="/preco-combustivel">Central Precos
</button> -->
  </div>
  <div class="col-2">
    <button class="btn btn-secondary float-left" data-toggle="modal" data-target="#ajudaModal"
            (click)="open(ajudaModel)"><i class="fa fa-question-circle-o" aria-hidden="true"></i>&nbsp;&nbsp;
      Ajuda
    </button>
  </div>
</div>



<!-- Modal Ajuda-->
<ng-template #ajudaModel let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="exampleModalLabel">Perguntas frequentes</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" aria-label="Close"
            (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div id="ajudaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <ngb-accordion id="accordion" #acc="ngbAccordion" [closeOthers]="true"
                         activeIds="collapseOne">
            <ngb-panel id="collapseOne">
              <ng-template ngbPanelTitle class="card-header" id="headingOne">
                <h5>
                  O que é o “Preço de Bomba”?
                </h5>
              </ng-template>
              <ng-template ngbPanelContent class="collapse show" aria-labelledby="headingOne"
                           data-parent="#accordion">
                <div class="card-body">
                  É o preço praticado pelo posto.
                </div>
              </ng-template>
            </ngb-panel>

            <ngb-panel>
              <ng-template ngbPanelTitle class="card-header" id="headingTwo">
                <h5>
                  O que é o “Preço para UVE”?
                </h5>
              </ng-template>
              <ng-template ngbPanelContent id="collapseTwo" class="collapse"
                           aria-labelledby="headingTwo" data-parent="#accordion">
                <div class="card-body">
                  É o preço que será utilizado para todos os abastecimentos de UVE no posto,
                  desde
                  que
                  a
                  frota não possua um AEP (Acordo Especial de Preço), nesse caso prevalece o
                  AEP.
                  <br>
                  Esse preço será apresentado no localizador de postos da CTF.
                </div>
              </ng-template>
            </ngb-panel>
            <ngb-panel>
              <ng-template ngbPanelTitle class="card-header" id="headingThree">
                <h5>
                  O que é o “Preço para Cartão”?
                </h5>
              </ng-template>
              <ng-template ngbPanelContent id="collapseThree" class="collapse"
                           aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                  É o preço que será praticado pelo posto para abastecimentos de cartão.
                  Se o valor informado no POS for superior a esse valor será concedido um
                  desconto
                  automático no momento da venda para que esse valor seja respeitado.
                  Se o valor informado no POS for inferior a esse valor o mesmo será mantido.
                  Esse preço será apresentado no localizador de postos da CTF.
                </div>
              </ng-template>
            </ngb-panel>

            <ngb-panel>
              <ng-template ngbPanelTitle class="card-header" id="headingFour">
                <h5>
                  O que é o “Preço para Frete”?
                </h5>
              </ng-template>
              <ng-template ngbPanelContent id="collapseFour" class="collapse"
                           aria-labelledby="headingFour" data-parent="#accordion">
                <div class="card-body">
                  É o preço que será praticado pelo posto para abastecimentos de Frete. <br>
                  Se o valor informado no POS for superior a esse valor será concedido um
                  desconto
                  automático no momento da venda para que esse valor seja respeitado.<br>
                  Se o valor informado no POS for inferior a esse valor o mesmo será mantido.
                  <br>
                  Esse preço será apresentado no localizador de postos da CTF.
                </div>
              </ng-template>
            </ngb-panel>

            <ngb-panel>
              <ng-template ngbPanelTitle class="card-header" id="headingFive">
                <h5 class="accordion-header">
                  O que é SPS?
                </h5>
              </ng-template>
              <ng-template ngbPanelContent id="collapseFive" class="collapse"
                           aria-labelledby="headingFive" data-parent="#accordion">
                <div class="card-body">
                  SPS ( Sistema de preço simplificado ) é a ferramenta do Sistema CTF pela
                  qual a
                  CTF
                  divulga e oferece a determinadas Frotas o Preço Negociado CTF para a
                  aquisição
                  de
                  Combustível e demais produtos e serviços CTF, equivalente à proposição de um
                  AEP
                  entre
                  posto e frota.
                  A inclusão de um preço para abastecimentos de UVE indica a aceitação da
                  participação
                  do
                  posto no SPS.

                  <a href="https://www.portalctf.com.br/portalposto/PrecoCombustivel/acordo.pdf"
                     target="_blank"> Segue
                    termo de adesão do SPS:</a>

                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>

        </div>
      </div>
    </div>
  </div>
</ng-template>
